"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _anyform = require("../anyform");
var _components = require("../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function PaginationFooter(_ref) {
  var page = _ref.page,
    pageSize = _ref.pageSize,
    count = _ref.count,
    total = _ref.total,
    _ref$sizes = _ref.sizes,
    initialPageSizes = _ref$sizes === void 0 ? [20, 50, 100] : _ref$sizes,
    _ref$pageSizeStyle = _ref.pageSizeStyle,
    pageSizeStyle = _ref$pageSizeStyle === void 0 ? 'buttons' : _ref$pageSizeStyle,
    skipPushToHistory = _ref.skipPushToHistory,
    onChangedPage = _ref.onChangedPage,
    onChangedPageSize = _ref.onChangedPageSize;
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var _useValidatedForm = (0, _anyform.useValidatedForm)(),
    register = _useValidatedForm.register;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(location.search);
  }, [location]);
  var effectivePageSize = (0, _react.useMemo)(function () {
    return Math.min(Math.max(pageSize, 0), 500);
  }, [pageSize]);
  var from = (0, _react.useMemo)(function () {
    return effectivePageSize * (page - 1) + (count === 0 ? 0 : 1);
  }, [effectivePageSize, page, count]);
  var to = (0, _react.useMemo)(function () {
    return effectivePageSize * (page - 1) + count;
  }, [effectivePageSize, page, count]);
  var textStyle = (0, _react.useMemo)(function () {
    return {
      fontSize: '0.875rem',
      fontWeight: 500
    };
  }, []);
  var pageSizes = (0, _react.useMemo)(function () {
    if (initialPageSizes.indexOf(effectivePageSize) >= 0) {
      return initialPageSizes;
    }
    return [].concat(_toConsumableArray(initialPageSizes), [effectivePageSize]).sort(function (a, b) {
      return a - b;
    });
  }, [initialPageSizes, effectivePageSize]);
  var updateRoute = (0, _react.useCallback)(function () {
    if (!skipPushToHistory) {
      history.push({
        pathname: location.pathname,
        state: location.state,
        search: query.toString()
      });
    }
  }, [skipPushToHistory, history, location, query]);
  var notifyPageSizeChange = (0, _react.useCallback)(function (newValue) {
    if (effectivePageSize === newValue) {
      return;
    }
    query.set('page', '1');
    query.set('pageSize', "".concat(newValue));
    updateRoute();
    onChangedPageSize(1, newValue);
  }, [query, updateRoute, onChangedPageSize, effectivePageSize]);
  var changedPageSize = (0, _react.useCallback)(function (name, value) {
    if (!value) {
      return;
    }
    var newValue = +value;
    notifyPageSizeChange(newValue);
  }, [notifyPageSizeChange]);
  var nextPage = (0, _react.useCallback)(function () {
    query.set('page', (page + 1).toString());
    updateRoute();
    onChangedPage(page + 1);
  }, [query, page, updateRoute, onChangedPage]);
  var previousPage = (0, _react.useCallback)(function () {
    query.set('page', (page - 1).toString());
    updateRoute();
    onChangedPage(page - 1);
  }, [query, page, updateRoute, onChangedPage]);
  var pageSizeOptions = (0, _react.useMemo)(function () {
    return pageSizes.map(function (el) {
      return "".concat(el);
    }).map(function (el) {
      return {
        value: el,
        label: el
      };
    });
  }, [pageSizes]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center",
    sx: {
      px: 1,
      mb: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto",
    sx: function sx(theme) {
      return {
        minWidth: theme.spacing(20)
      };
    }
  }, pageSizeStyle === 'buttons' ? (/*#__PURE__*/_react["default"].createElement(_material.Stack, {
    direction: "row",
    spacing: 1
  }, pageSizes.map(function (el) {
    return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
      key: el,
      label: el,
      size: "small",
      color: effectivePageSize === el ? 'primary' : 'default',
      component: _material.IconButton,
      onClick: function onClick() {
        return notifyPageSizeChange(el);
      }
    });
  }))) : (/*#__PURE__*/_react["default"].createElement(_anyform.AnyAutocomplete, {
    name: "pageSize",
    label: (0, _core.translate)('pagination.page_size'),
    size: "small",
    margin: "none",
    initialValue: "".concat(effectivePageSize),
    options: pageSizeOptions,
    register: register,
    notifier: changedPageSize
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "span",
    variant: "body2",
    sx: textStyle
  }, (0, _core.translate)('pagination.status', {
    from: from,
    to: to,
    total: total
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "Previous page",
    onClick: previousPage,
    disabled: page === 1
  }, /*#__PURE__*/_react["default"].createElement(_components.LeftIcon, null)), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "Next page",
    onClick: nextPage,
    disabled: count === 0 || count < effectivePageSize
  }, /*#__PURE__*/_react["default"].createElement(_components.RightIcon, null))))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(PaginationFooter);